import { Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import {
    AUTH_ROUTES,
    canActivateAdmin,
    canActivateRequests,
    canActivateTasks,
    canActivateUser
} from '@shs-digi-care-monorepo/frontend-lib/auth';
import { PendingRequestsComponent } from '@shs-digi-care-monorepo/frontend-lib/components/pending-requests/pending-requests.component';

export const APP_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./menu/menu.component').then((m) => m.MenuComponent),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'request',
        loadComponent: () => import('./request/request.component').then((m) => m.RequestComponent),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'request/:id',
        loadComponent: () => import('./request-detail/request-detail.component').then((m) => m.RequestDetailComponent),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'requests',
        loadComponent: () => import('./requests/tasks.component').then((m) => m.TasksComponent),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser, canActivateRequests],
        data: { mode: 'requests' }
    },
    {
        path: 'tasks',
        loadComponent: () => import('./requests/tasks.component').then((m) => m.TasksComponent),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser, canActivateTasks],
        data: { mode: 'tasks' }
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser, canActivateAdmin]
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'escalation/pending-requests',
        component: PendingRequestsComponent,
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'auth',
        children: AUTH_ROUTES
    },
    {
        path: '**',
        redirectTo: ''
    }
];
